import api from '../../baseApi';
import {isDebugging} from '../../../utility';
import axios, {AxiosResponse} from 'axios';

type Response = {
  status: 'SUCCESS' | 'FAILURE';
  message: string;
};

const forgotPasswordPort = '/recoverAccount';

const forgotPasswordAPI =
async (email: string, username: string, captchaToken: string): Promise<AxiosResponse<Response>> => {
  // const ipRes = await axios.get('https://geolocation-db.com/json/');
  const res = await api.get(forgotPasswordPort, {
    params: {
      rtype: 'pwordLink',
      email: email,
      username: username
    },
    headers: {
      // remoteip: ipRes.status === 200 ? ipRes.data.IPv4 : '',
      remoteip: '',
      captchaToken: captchaToken
    }
  });

  if (isDebugging) {
    console.log(`${forgotPasswordPort} response:`, res);//TESTING
  }

  return res;
};

export default forgotPasswordAPI;